import { Link } from "react-router-dom";
import { CATEGORY_KEYS, categoryMeta, countByCategory } from "@/lib/catalog";

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto max-w-shell px-4 pt-12 md:px-8 md:pt-14">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {CATEGORY_KEYS.map((key) => {
          const meta = categoryMeta[key];
          const count = countByCategory(key);
          return (
            <Link
              key={key}
              to={`/category/${encodeURIComponent(key)}`}
              className="group flex cursor-pointer flex-col justify-between rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-700">
                  <i className={`${meta.icon} text-xl`} />
                </span>
                <span className="font-label text-[11px] uppercase tracking-[0.18em] text-secondary-500">
                  {meta.en}
                </span>
              </div>
              <div className="mt-5 flex items-end justify-between gap-3">
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{meta.name}</h3>
                  <p className="mt-1 text-[12px] leading-relaxed text-foreground-600">{meta.description}</p>
                </div>
                <span className="flex shrink-0 items-center gap-1 font-label text-[11px] text-primary-700">
                  {count} 部
                  <i className="ri-arrow-right-up-line text-xs transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}